import { AppBar, AppBarLogo } from 'common-ui-components';
import LogoClaro from '../assets/images/claro.png';

const Header = () => {
  return (
    <AppBar className='header'>
      <AppBarLogo src={LogoClaro} width={76} height={25} alt='MiClaro' />
    </AppBar>
  );
};

export default Header;